module.exports = __webpack_public_path__ + "media/dark-mode.35fc1b1a.webm";